import Model from "../Model.js";

/**
 * Transaction inside a manual entry journal.
 *
 * @param {Account} account - Account to credit/debit
 * @param {number} value - Any number. If positive, it's considered a credit,
 *   otherwise it's considered a debit
 */
export default class ManualJournalEntryTransaction extends Model {
	constructor({ account, value = 0 }) {
		super(...arguments);

		this._account = account;
		this._value = value;
	}

	getAccount() {
		return this._account;
	}

	getAccountNumber() {
		return this._account.getNumber();
	}

	getValue() {
		return this._value;
	}

	getCredit() {
		return this._value <= 0 ? -this._value : undefined;
	}

	getDebit() {
		return this._value >= 0 ? this._value : undefined;
	}

	setAccount(account) {
		this._account = account;
	}

	setValue(value) {
		this._value = value;
	}

	isForAccountNumber(accountNumber) {
		return this._account.getNumber() === accountNumber;
	}

	/**
	 * We need to override this method because otherwise new instances of
	 * Account are created, leading to some mismatch.
	 */
	clone() {
		return new this.constructor({
			account: this._account,
			value: this._value,
		});
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.accountNumber = this._account.getNumber();
		properties.value = this._value;

		return properties;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.account = context.findAccountByNumber(data.accountNumber);
	}
}
